import React from 'react';

import { PageTitle } from '../../../components';
import { Booking } from '../../../sections';



const TourBooking = () => {

  return (

    <div className='booking-page'>

      {/* Page Title */}
      <PageTitle title={'Tour Booking'} page={'Tour Booking'} />

      {/* Booking Form */}
      <Booking />

    </div>

  );

}

export default TourBooking;